import React, { useEffect } from "react"

const TimelineMobile = ({ widthCol, propsTimelines }) => {
  const { hoursNowComp, minutesNowComp, emPosition, extraMinutes, isDesktopNormal } = propsTimelines
  
  const setTimelineMobile = () => {
    const timeline = document.querySelector('.time-line-mobile')
    const diffAdd = emPosition * widthCol
    const diffMinutesAdd = (widthCol / 30) * extraMinutes
    const finalAdd = diffAdd + diffMinutesAdd
    timeline.style.left = 94 + finalAdd + 'px'
  }

  useEffect(() => {
    const intervalTimelineMobile = setInterval(() => {
      setTimelineMobile()
    }, 60000)
  
    return () => clearInterval(intervalTimelineMobile)
  }, [])
  

  useEffect(() => {
    !isDesktopNormal && setTimelineMobile()
  }, [isDesktopNormal])
  
  
  let styleTimeline = {
    left: '92px',
    opacity: 0
  }
  if (!isDesktopNormal) {
    styleTimeline = {
      left: '94px',
      opacity: 1
    }
  }
  
  return (
    <>
      <div className="time-line-mobile" style={styleTimeline}>
        <p>{hoursNowComp}:{minutesNowComp}</p>
      </div>
    </>
  )
}

export default React.memo(TimelineMobile)
